var RouterParamsService_1;
import { __decorate } from "tslib";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { filter } from "rxjs/operators";
import { AutoUnsub } from "../decorators/autounsub.decorator";
let RouterParamsService = class RouterParamsService {
    static { RouterParamsService_1 = this; }
    router;
    paramsSnapshot;
    params;
    _paramsSubject;
    url = null;
    eventsSubscription;
    constructor(router) {
        this.router = router;
        this.initializeParamData();
        this.handleNavigationEnd();
        this.listenForRouterEvents();
    }
    static checkIfUrlChanged(newValue, oldValue) {
        if (!newValue) {
            throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    static checkParamsAreDifferent(currentParams, nextParams) {
        const currentKeys = Object.keys(currentParams);
        const nextKeys = Object.keys(nextParams);
        if (currentKeys.length !== nextKeys.length) {
            return true;
        }
        for (let i = 0, length = currentKeys.length; i < length; i++) {
            const key = currentKeys[i];
            if (currentParams[key] !== nextParams[key]) {
                return true;
            }
        }
        return false;
    }
    getParams(root) {
        const params = {};
        (function mergeParamsFromSnapshot(snapshot) {
            Object.assign(params, snapshot.params);
            snapshot.children.forEach(mergeParamsFromSnapshot);
        })(root);
        return (params);
    }
    listenForRouterEvents() {
        this.eventsSubscription = this.router.events
            .pipe(filter((event) => {
            return (event instanceof NavigationEnd);
        }))
            .subscribe((event) => {
            if (!event.url.endsWith("/refresh") && RouterParamsService_1.checkIfUrlChanged(event.url, this.url)) {
                this.url = event.url;
                this.handleNavigationEnd();
            }
        });
    }
    handleNavigationEnd() {
        const snapshot = this.router.routerState.snapshot.root;
        const nextParams = this.getParams(snapshot);
        if (RouterParamsService_1.checkParamsAreDifferent(this.paramsSnapshot, nextParams)) {
            this._paramsSubject.next(this.paramsSnapshot = nextParams);
        }
    }
    initializeParamData() {
        this.paramsSnapshot = {};
        this._paramsSubject = new BehaviorSubject(this.paramsSnapshot);
        this.params = this._paramsSubject.asObservable();
    }
    static ctorParameters = () => [
        { type: Router }
    ];
};
RouterParamsService = RouterParamsService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], RouterParamsService);
export { RouterParamsService };
